// extracted by mini-css-extract-plugin
export default {"filesContainer":"bRCu5rysztZl5UDKfcld","uploadBtn":"JwQaX5hsTC20hYkhTUjG","chip":"jklvf0jXn50HUPyOuk7N"};